<template>
    <v-form-item
        name="menuColor"
        label="按钮主题色"
        class="form-item-colorselect"
    >
        <div class="webim-color-select__radio">
            <v-radio-group
                v-model="innerValue.value"
                @input="onChangeColor"
                class="color-list"
            >
                <v-radio
                    v-for="colorItem in colorList"
                    :key="colorItem.value"
                    :value="colorItem.value"
                    :class="'color-' + colorItem.value"
                    class="color-list__cell"
                    name="webim-color"
                >
&nbsp;
                </v-radio>
                <v-radio
                    :key="CUSTOMER_COLOR_VALUE"
                    :value="CUSTOMER_COLOR_VALUE"
                    class="color-list__color-picker"
                    name="webim-color"
                >
                    <div class="trigger-color-picker" />
                </v-radio>
            </v-radio-group>
            <div class="ui-input-color">
                <div class="ui-input-color__content">
                    <span class="ui-input-color__sign">#</span>
                    <input
                        ref="colorInput"
                        :value="(innerValue.color||'').replace(/^#/,'')"
                        @change="onChangeColorInput"
                        @focus="onFocusColorInput"
                        class="ui-input-color__input"
                        type="text"
                        maxlength="6"
                        placeholder="输入色值"
                    >
                    <div
                        v-popper:color.click
                        class="trigger-popper-placeholder"
                    >
                        <div
                            :style="colorStyle"
                            class="ui-input-color__preview"
                        />
                        <v-icon
                            class="ui-input-color__arrow"
                            name="arrow_dropdown"
                        />
                    </div>
                </div>
                <v-popper
                    ref="color"
                    :offset="-97"
                    clazz="ui-input-color__popper"
                    placement="bottom-start"
                    priority="tunning"
                >
                    <chrome-picker
                        :value="innerValue.color"
                        @input="onChangeColorPicker"
                    />
                </v-popper>
            </div>
        </div>
    </v-form-item>
</template>

<script>
import { Icon } from 'vhtml-ui';
import VueColor from 'vue-color';
import { THEME_CONFIG, CUSTOMER_COLOR_VALUE } from '../conf';

const commonSprites = require.context('@/assets/icons', true, /[^.]+\.svg$/);
const sprites = require.context('../../assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(commonSprites);
Icon.addSprites(sprites);

export default {
    components: {
        'chrome-picker': VueColor.Chrome,
    },

    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            // 主题列表
            colorList: [
                {
                    value: 0,
                },
                {
                    value: 1,
                },
                {
                    value: 2,
                },
                {
                    value: 3,
                },
                {
                    value: 4,
                },
                {
                    value: 5,
                },
            ],
            CUSTOMER_COLOR_VALUE,

            // 默认值
            innerValue: {
                value: 0,
                color: '#566076',
                borderAdaptTextColor: false,
            },
        };
    },

    computed: {
        colorStyle() {
            return {
                backgroundColor: this.innerValue.color,
            };
        },
    },

    watch: {
        value() {
            this.innerValue = { ...this.innerValue, ...this.value };
        },
    },
    mounted() {
        this.innerValue = { ...this.innerValue, ...this.value };
    },
    methods: {
        // 切换颜色
        onChangeColor(value) {
            if (value === undefined) return;
            let color = '';
            if (value !== CUSTOMER_COLOR_VALUE) {
                color = `#${THEME_CONFIG[value].color}`;

                this.updateColor(value, color);
            } else {
                this.$nextTick(() => {
                    this.$refs.colorInput.select();
                });
            }
        },

        // 自动选中内容
        onFocusColorInput(e) {
            e.target.select();
        },

        // 输入自定义颜色
        onChangeColorInput(e) {
            const reg = /([\da-fA-F]{3}){1,2}/;
            const regColorWord = /[^\da-fA-F]/g;
            const { value } = e.target;

            if (reg.exec(value) && reg.exec(value)[0] === value) {
                this.updateColor(-1, `#${value}`);
            } else {
                // 自动修复颜色
                let newStr = '';
                const newStrArr = [];
                newStr = value.replace(regColorWord, '0');
                for (let i = 0; i < 6; i += 1) {
                    newStrArr[i] = newStr[i] || '0';
                }
                this.updateColor(-1, `#${newStrArr.join('')}`);
            }
        },

        // 选择自定义颜色
        onChangeColorPicker(c) {
            this.updateColor(-1, c.hex);
        },

        // 更新
        updateColor(value, color) {
            this.innerValue = {
                ...this.innerValue,
                value,
                color,
            };

            this.$emit('input', { ...this.innerValue });
            this.$emit('change', { ...this.innerValue });
        },
    },
};
</script>

<style lang="less" scoped>
@import './common';
@import './style';
</style>
